import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_FR.json';
import exercises from './PILATES_EXERCISES_FR.json';
import recipes from './PILATES_RECIPES_FR.json';

export const PILATES_DATA_FR: ServiceData = {
  articles,
  exercises,
  recipes,
};
